<svg
  xmlns="http://www.w3.org/2000/svg"
  xml:space="preserve"
  version="1.1"
  viewBox="0 0 72 72"
>
  <path d="M0,0 L72,0 L72,72 L0,72 Z" fill="#ffffff" />
</svg>
